module.exports = __webpack_public_path__ + "img/the-legendary.2aaf11f6.gif";